import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'financial'

export function selectAll(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/page`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function pageInfo(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/pageInfo`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function incomeStatistics(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/incomeStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function pageInfoStatistics(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/pageInfoStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function pageHarvest(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/pageHarvest`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function analysis(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/analysis`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function analysisIncomeFali(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/analysisIncomeFali`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function analysisIncomeSucess(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/analysisIncomeSucess`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectCustomerAll(parameter) {
  console.log('financial:', parameter)
  return axios({
    url: `/ws/${moduleName}/pageCustomerAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function selectOne(id) {
  console.log('id:', id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get'
  })
}


export function selectOneByDealComfrimId(id) {
  console.log('id:', id)
  return axios({
    url: `/ws/${moduleName}/selectOneByDealComfrimId/${id}`,
    method: 'get'
  })
}

export function getFinancialNumber() {

  return axios({
    url: `/ws/${moduleName}/getFinancialNumber`,
    method: 'get'
  })
}

export function getIncomeById(id) {
  console.log('id:', id)
  return axios({
    url: `/ws/${moduleName}/getIncomeById/${id}`,
    method: 'get'
  })
}

export function getIncomeByFinId(id,type) {
  console.log('id:', id)
  return axios({
    url: `/ws/${moduleName}/getIncomeByFinId/${id}/${type}`,
    method: 'get'
  })
}

export function selectReceivableByDealConfirmId(id) {
  console.log('id:', id)
  return axios({
    url: `/ws/${moduleName}/selectReceivableByDealConfirmId/${id}`,
    method: 'get'
  })
}

export function selectByCustomer(customerId,payerId,payer,payerType) {
  console.log('id:', customerId)
  console.log('payerId:', payerId)
  console.log('payer:', payer)
  console.log('payerType1:', payerType)
  return axios({
    url: `/ws/${moduleName}/customer/${customerId}/${payerId}/${payer}/${payerType}`,
    method: 'get'
  })
}

export function selectInfoByCustomer(parameter) {
  console.log('id:', parameter)
  return axios({
    url: `/ws/${moduleName}/info`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function getAllIncome(parameter) {
  console.log('id:', parameter)
  return axios({
    url: `/ws/${moduleName}/getAllIncome`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getAllMonthIncome(parameter) {
  console.log('id:', parameter)
  return axios({
    url: `/ws/${moduleName}/getAllMonthIncome`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function insert(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data: parameter
  })
}

export function payment(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/collection`,
    method: 'put',
    data: parameter
  })
}
export function updateReceivable(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/updateReceivable`,
    method: 'put',
    data: parameter
  })
}

export function userUpdateReceivable(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/userUpdateReceivable`,
    method: 'put',
    data: parameter
  })
}

export function deskTopupdateReceivable(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/deskTopupdateReceivable`,
    method: 'put',
    data: parameter
  })
}

export function update(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data: parameter
  })
}

export function updatePreNumbers(id) {
  console.log('data:', id)
  return axios({
    url: `/ws/${moduleName}/updatePreNumbers/${id}`,
    method: 'put'
  })
}

export function exportReceivablePage(parameter){
  console.log("parameter : ",parameter)
  return axios({
    url: `/ws/${moduleName}/exportReceivablePage`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType:'blob'
  })
}

export function exportReceivableAll(parameter){
  console.log("parameter : ",parameter)
  return axios({
    url: `/ws/${moduleName}/exportReceivableAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType:'blob'
  })
}

export function exportIncomeSucess(parameter){
  console.log("parameter : ",parameter)
  return axios({
    url: `/ws/${moduleName}/exportIncomeSucess`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType:'blob'
  })
}

export function exportIncomeFail(parameter){
  console.log("parameter : ",parameter)
  return axios({
    url: `/ws/${moduleName}/exportIncomeFail`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType:'blob'
  })
}



export default {
  save: insert,
  update,
  incomeStatistics,
  queryById: selectOne,
  selectByCustomer: selectByCustomer,
  selectInfoByCustomer: selectInfoByCustomer,
  payment: payment,
  updateReceivable: updateReceivable,
  deskTopupdateReceivable: deskTopupdateReceivable,
  selectCustomerAll: selectCustomerAll,
  selectAll: selectAll,
  analysis: analysis,
  analysisIncomeFali: analysisIncomeFali,
  analysisIncomeSucess: analysisIncomeSucess,
  getAllIncome: getAllIncome,
  getAllMonthIncome: getAllMonthIncome,
  getIncomeById: getIncomeById,
  exportIncomeFail:exportIncomeFail,
  exportIncomeSucess:exportIncomeSucess,
  exportReceivableAll:exportReceivableAll,
  exportReceivablePage:exportReceivablePage,
  getIncomeByFinId:getIncomeByFinId,
  pageHarvest:pageHarvest,
  getFinancialNumber,
  pageInfo,
  userUpdateReceivable,
  pageInfoStatistics,
  selectOneByDealComfrimId,
  selectReceivableByDealConfirmId
}